import { css } from '@emotion/react';
import { PropsWithChildren } from 'react';

import { theme } from './theme';

const style = css`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  max-width: ${theme.breakpoints.values.desktop + 48}px;
  margin: 0 auto;
  padding: 0 16px;
`;

export function Content({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={className} css={style}>
      {children}
    </div>
  );
}
